import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clark-toaster-crust',
  template: '<clark-toastr-oven></clark-toastr-oven>',
})
export class CrustComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
